import {defineAsyncComponent} from 'vue'

const CpeBudgetsChilrensRouter = [
  {
    path: 'budgets',
    name: 'CpeBudgets',
    component: () => import('@/views/CpeBudgets/Budgets/Index.vue'),
    meta: {
      key: 'cpe_budgets'
    },
  },
  {
    path: 'cpe_settlement_rule',
    name: 'CpeSettleRule',
    component: () => import('@/views/Cpes/CpeSettleRule/Index.vue'),
    meta: {
      key: 'cpe_budgets'
    },
  },
  {
    path: 'cpe_settlement_datas',
    name: 'CpeSettleData',
    component: () => import('@/views/Cpes/CpeSettleData/Index.vue'),
    meta: {
      key: 'cpe_budgets'
    },
  },
  {
    path: 'cpe_profit',
    name: 'CpeProfit',
    component: () => import('@/views/CpeBudgets/CpeProfit/Index.vue'),
    meta: {
      key: 'cpe_budgets'
    },
  },
]

const CpeBudgetsRouter = [
  {
    path: 'cpe_budgets',
    name: 'cpe_budget',
    redirect: 'CpeBudgets',
    meta: {
      key: 'cpe_budgets'
    },
    children: CpeBudgetsChilrensRouter
  }
]

export {CpeBudgetsRouter}
